<template>
  <div id="chart">
    <highcharts v-if="sectionData.length" :options="sectionChartOptions" />
  </div>
</template>

<script>
const colors = {
  warning: '#FFC107',
  alarm: '#DC3545',
  grey: 'grey'
}
export default {
  name: 'shuntChart',
  props: {
    asset: { type: Object, required: false },
    value: { type: Object, required: true },
    sectionData: { type: Array, required: true }
  },
  data () {
    return {
      alarmSettings: this.value,
      measurement: this.sectionData,
      shuntStart: null,
      shuntEnd: null,
      sectionChartOptions: {
        chart: {
          height: '400px',
          zoomType: null,
          animation: false
        },
        navigator: {
          enabled: false
        },
        exporting: {
          enabled: false
        },
        title: {
          text: 'Shunt'
        },
        tooltip: {
          enabled: false
        },
        credits: {
          enabled: false
        },
        yAxis: {
          title: {
            text: ''
          }
        },
        xAxis: {
          plotBands: [
            { id: 'shuntThreshold' }
          ]
        },
        plotOptions: {
          series: {
            stickyTracking: false,
            marker: false
          },
          line: {
            stickyTracking: false,
            enableMouseTracking: false
          }
        },
        series: [
          { id: 'shunt', name: 'Shunt', data: [], dragDrop: false, enableMouseTracking: false, lineWidth: 5 },
          { id: 'warning', name: 'Warning', data: [], color: colors.warning, zIndex: 100 },
          { id: 'alarm', name: 'Alarm', data: [], color: colors.alarm, zIndex: 100 },
          { id: 'shuntThreshold', name: 'Shunt threshold', data: [], color: colors.grey, zIndex: 100 }
        ]
      }
    }
  },
  async mounted () {
    await this.load()
  },
  methods: {
    updateChart () {
      if (!this.measurement) {
        return
      }

      const shuntStartMeasurement = this.measurement.find(v => v.y < this.alarmSettings.shuntThreshold)
      const shuntEndMeasurement = this.measurement.slice().reverse().find(v => v.y < this.alarmSettings.shuntThreshold)
      this.shuntStart = shuntStartMeasurement ? shuntStartMeasurement.x : 0
      this.shuntEnd = shuntEndMeasurement ? shuntEndMeasurement.x : Math.max(...this.measurement.map(v => v.x))

      this.updateAxis(this.alarmSettings)

      return this
    },
    updateAxis (alarmSettings) {
      if (!alarmSettings) {
        throw new Error('alarmSettings is invalid')
      }

      this.setSerie(alarmSettings.warningThreshold, this.shuntStart, this.shuntEnd, 'warning')
      this.setSerie(alarmSettings.alarmThreshold, this.shuntStart, this.shuntEnd, 'alarm')
      this.setSerie(alarmSettings.shuntThreshold, this.shuntStart, this.shuntEnd, 'shuntThreshold')
      this.setPlotband({ from: this.shuntStart, to: this.shuntEnd, id: 'shuntThreshold' })

      return this
    },
    setSerie (yVal, serieStart, serieEnd, id) {
      const serie = this.sectionChartOptions.series.find(s => s.id === id)
      if (!serie) {
        throw new Error(`Could not find serie ${id}`)
      }

      yVal = parseFloat(yVal)
      serie.data = [{ x: serieStart, y: yVal, groupId: id }, { x: serieEnd, y: yVal, groupId: id }]
    },
    setPlotband (plotBand, xAxis = true) {
      if (!plotBand) {
        throw new Error('plotBand is invalid')
      }

      const axis = xAxis ? this.sectionChartOptions.xAxis : this.sectionChartOptions.yAxis
      const pb = axis.plotBands.find(pb => pb.id === plotBand.id)
      if (!pb) {
        throw new Error(`Could not find plotband '${plotBand.id}'`)
      }

      pb.from = plotBand.from
      pb.to = plotBand.to
      return this
    },
    setData () {
      if (!this.measurement) {
        return
      }

      const serie = this.sectionChartOptions.series.find(s => s.id === 'shunt')
      if (!serie) {
        throw new Error('Could not find serie')
      }

      serie.data = this.measurement
    },
    async load () {
      this.setData()
      // wait for next redraw, so extremes are set.
      this.$nextTick(() => this.updateChart())
    }
  },
  watch: {
    value: {
      deep: true,
      handler (val) {
        this.alarmSettings = val
        this.updateChart()
      }
    }
  }
}
</script>

<style scoped>
  .highcharts-plot-line:hover, .highcharts-line-series.draggable:hover { cursor: pointer; }
  #chart { position: relative; }
  #chart > .highcharts-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 400;
    background: #eee;
    opacity: 0.5;
  }
</style>



// WEBPACK FOOTER //
// src/pages/axleshunt/AlarmSettings/_shuntChart.vue